import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import styled from 'styled-components';
import { ISegmentationClass } from 'models/icardio';

const OptionItem = styled.li<{ $bg: string; $fg: string }>`
  font-family: inherit;
  font-size: 14px;
  background-color: ${({ $bg }) => $bg} !important;
  color: ${({ $fg }) => $fg} !important;

  &.Mui-focused,
  &[aria-selected='true'],
  &:hover {
    background-color: ${({ $bg }) => $bg} !important;
    color: ${({ $fg }) => $fg} !important;
  }
`;

interface Props {
  segmentationClasses: ISegmentationClass[];
  activeSegmentationClass: ISegmentationClass;
  segmentations: any[];
  segmentationReferences: any;
  activeFrame: any;
  setActiveSegmentationClass: (segClass: ISegmentationClass) => void;
}

const FeatureDropdown: React.FC<Props> = ({
  segmentationClasses,
  activeSegmentationClass,
  segmentations,
  segmentationReferences,
  activeFrame,
  setActiveSegmentationClass,
}) => {
  return (
    <Autocomplete
      options={segmentationClasses}
      getOptionLabel={option => option.value}
      value={activeSegmentationClass}
      onChange={(_, newValue) => {
        if (newValue) {
          setActiveSegmentationClass(newValue);
        }
      }}
      isOptionEqualToValue={(option, value) => option.uuid === value.uuid}
      renderOption={(props, option) => {
        const segmentation = segmentations?.find(
          s => s?.segmentationClass === option.uuid && s?.frame === activeFrame?.uuid
        );

        const isLabeled = !!segmentation?.paths?.length || segmentation?.isFullyVisible === false;
        const isActive = activeSegmentationClass.uuid === option.uuid;
        const hasReference = segmentationReferences?.some(
          (r: any) => r?.segmentationClass === option.uuid && r?.frame === activeFrame?.uuid
        );

        // Priority: Active > Labeled > HasReference > default (colors unchanged)
        let bg = 'inherit';
        if (isActive) bg = '#2a98e8';
        else if (isLabeled) bg = 'lightpink';
        else if (hasReference) bg = '#9bd5ed';

        let fg = 'inherit';
        if (isActive || isLabeled) fg = '#000';
        else if (hasReference) fg = '#fff';

        return (
          <OptionItem {...props} $bg={bg} $fg={fg} style={{ backgroundColor: bg, color: fg }}>
            {option.value}
          </OptionItem>
        );
      }}
      sx={{
        '& .MuiOutlinedInput-root': {
          padding: '6px 10px',
          fontFamily: 'inherit',
          fontSize: '14px',
          backgroundColor: '#532e63',
          color: 'white',
          borderRadius: '5px',
        },
        '& .MuiAutocomplete-popupIndicator, & .MuiAutocomplete-clearIndicator': {
          color: 'white',
        },
        '& .MuiAutocomplete-input': {
          color: 'white',
          WebkitTextFillColor: 'white',
        },
      }}
      renderInput={params => (
        <TextField
          {...params}
          label=""
          variant="outlined"
          InputLabelProps={{ style: { color: 'white' } }}
        />
      )}
    />
  );
};

export default FeatureDropdown;
